"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = require("immutable");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _UIAdminOnlyWrapper = _interopRequireDefault(require("ui-addon-upgrades/decorators/UIAdminOnlyWrapper"));

var _AdminModalTypes = require("ui-addon-upgrades/_core/common/constants/AdminModalTypes");

var _AdminTypes = require("ui-addon-upgrades/_core/common/constants/AdminTypes");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _QuoteApi = require("../../api/QuoteApi");

var _urls = require("../../utils/urls");

var _getRelevantQuote = require("../../utils/getRelevantQuote");

var ActiveQuoteBanner =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ActiveQuoteBanner, _Component);

  function ActiveQuoteBanner() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ActiveQuoteBanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ActiveQuoteBanner)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      activeQuotes: (0, _immutable.List)(),
      currentState: 'INITIAL'
    };

    _this.handleViewQuote = function () {
      _this.trackBannerInteraction('view-active-quote-banner');
    };

    _this.handleClickQuote = function (relevantQuote) {
      _this.trackBannerInteraction('click-active-quote-banner');

      (0, _urls.handleRedirect)((0, _urls.getActiveQuoteUrl)(relevantQuote.get('id')));
    };

    _this.handleDismiss = function () {
      _this.trackBannerInteraction('dismiss-active-quote-banner');

      _this.setState({
        currentState: 'DISMISSED'
      });
    };

    return _this;
  }

  (0, _createClass2.default)(ActiveQuoteBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.isMounted_ = true;
      (0, _QuoteApi.fetchActiveQuotes)().then(function (activeQuotes) {
        if (!_this2.isMounted_) return;

        _this2.setState({
          currentState: 'SUCCESS',
          activeQuotes: activeQuotes
        });

        _this2.handleViewQuote();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isMounted_ = false;
    }
  }, {
    key: "trackBannerInteraction",
    value: function trackBannerInteraction(name) {
      (0, _getUsageTracker.default)().track('bannerInteraction', {
        name: name
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          activeQuotes = _this$state.activeQuotes,
          currentState = _this$state.currentState;
      if (currentState !== 'SUCCESS') return null;
      var relevantQuote = (0, _getRelevantQuote.getRelevantQuote)(activeQuotes, this.props.hub);
      if (!relevantQuote) return null;
      return _react.default.createElement("div", {
        "data-selenium-id": "active-quote-banner"
      }, _react.default.createElement(_UIAlert.default, {
        type: "info",
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: "activeQuote.title"
        })
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "activeQuote.text"
      }), _react.default.createElement(_UIAdminOnlyWrapper.default, {
        adminType: _AdminTypes.BILLING,
        modalType: _AdminModalTypes.REQUEST_QUOTE,
        quoteLink: (0, _urls.getActiveQuoteUrl)(relevantQuote.get('id'))
      }, _react.default.createElement(_UIButton.default, {
        className: "m-left-4",
        use: "tertiary",
        size: "small",
        onClick: function onClick() {
          for (var _len2 = arguments.length, partialArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            partialArgs[_key2] = arguments[_key2];
          }

          return _this3.handleClickQuote.apply(_this3, [relevantQuote].concat(partialArgs));
        },
        "data-selenium-id": "active-quote-purchase-button"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "activeQuote.link"
      }))), _react.default.createElement(_UIButton.default, {
        className: "m-left-4",
        use: "tertiary-light",
        size: "small",
        onClick: this.handleDismiss
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "activeQuote.dismiss"
      }))));
    }
  }]);
  return ActiveQuoteBanner;
}(_react.Component);

var _default = ActiveQuoteBanner;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/ActiveQuoteBanner.js
// module id = 790
// module chunks = 5 6